<template>
    <div>
        <ul class="small mb-0">
            <li>Okno świadczenia usług: <b>{{window}}</b></li>
            <li>Dostępność w dni wolne: <b>{{config.sla_everyday ? 'TAK' : 'NIE'}}</b></li>
            <li>Czas na realizację: <b>{{period}}</b></li>
            <li v-if="config.workaround_deadline_extend">Potencjalne przesunięcie terminu realizacji z tytułu wprowadzenia rozwiązania tymczasowego: <b>{{config.workaround_deadline_extend + (config.sla_everyday ? ' [dni]' : ' [dni robocze]')}}</b></li>
        </ul>
    </div>
</template>

<script>
export default {
    name: "sla-details",
    props: {
        config: {
            type: Object,
            required: true
        }
    },
    computed: {
        window: function () {
            if (this.config.sla_from === '00:00' && this.config.sla_to === '00:00') {
                return this.$lang('całodobowo');
            } else {
                return this.config.sla_from + " - " + this.config.sla_to;
            }
        },
        period: function () {
            if (this.config.unit === 'days') {
                if (this.config.number_of_unit > 1) {
                    return this.config.number_of_unit + ' dni';
                }
                return '1 dzień';
            } else {
                if (this.config.number_of_unit > 1) {
                    if (this.config.number_of_unit > 4) {
                        return this.config.number_of_unit + ' godzin';
                    }
                    return this.config.number_of_unit + ' godziny';
                }
                return '1 godzina';
            }
        }
    }
}
</script>
